import { Link } from 'react-router-dom';
import { useServicesGrouped } from '../hooks/useApi';
import SkeletonServiceGroup from '../components/SkeletonServiceGroup';
import { ChevronRight, ArrowRight } from 'lucide-react';

export default function ServicesPage() {
  const { data: categories, isLoading } = useServicesGrouped();

  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <ChevronRight className="w-3.5 h-3.5" />
        <span className="text-navy font-medium">Services</span>
      </div>

      <h1 className="text-3xl font-extrabold text-navy">Healthcare Services</h1>
      <p className="text-gray-400 mt-2 mb-8">Services available across community health clinics</p>

      {isLoading ? (
        <SkeletonServiceGroup count={3} />
      ) : (
        <div className="space-y-10">
          {categories?.map((cat) => (
            <div key={cat.category}>
              <h2 className="text-xl font-bold text-navy mb-4">{cat.category}</h2>
              <div className="grid md:grid-cols-3 gap-4">
                {cat.services.map((service) => (
                  <div key={service.id} className="card hover:shadow-md transition-shadow">
                    <span className="w-10 h-10 bg-primary-50 rounded-lg flex items-center justify-center mb-3">
                      <span className="text-primary font-bold">+</span>
                    </span>
                    <h3 className="font-bold text-navy">{service.name}</h3>
                    {service.description && (
                      <p className="text-sm text-gray-500 mt-1">{service.description}</p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="text-center mt-12">
        <Link to="/clinics" className="btn btn-primary">
          Find Clinics Offering These Services
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
